<template>
  <div class="authc-home account-page">
	  <div id="finish">
		  <div v-if="$store.state.userAuth == 20">
			  <div class="finish-ent">
				  <div class="finishImgNav">
					  <img src="../../assets/icon/ent1.png" alt="">
				  </div>
				  <div class="finishConNav">
					  <div class="congratulations">恭喜！&nbsp;您已完成叮咚智造企业实名认证</div>
					  <div class="belowcongratulations">
						  <div class="congratulationsother">企业名称:</div>
						  <div class="congratulationsother">{{name}}</div>
					  </div>
					  <div class="belowcongratulations">
						  <div class="congratulationsother">证件号码:</div>
						  <div class="congratulationsother">{{code}}</div>
					  </div>
				  </div>
			  </div>
		  </div>
		  <div v-if="$store.state.userAuth == 10">
			  <div class="finish-person">
			  		<div class="finishImgNav">
						<img src="../../assets/icon/user1.png" alt="">
					</div>
			  		<div class="finishConNav">
						<div class="congratulationsPerson">恭喜！&nbsp;您已完成叮咚智造个人实名认证</div>
						<div class="belowcongratulations">
							<div class="congratulationsother">真实姓名:</div>
							<div class="congratulationsother">{{name}}</div>
						</div>
						<div class="belowcongratulations">
							<div class="congratulationsother">证件号码:</div>
							<div class="congratulationsother">{{code}}</div>
						</div>
						<div>
							<router-link :to="{name:'AuthcEnt'}">
							  <div id="change" @click="change">变更为企业认证&gt;&gt;</div>
							</router-link>
						</div>
					</div>
			  </div>
		  </div>
	  </div>
  </div>
</template>

<script>
  export default {
    name: 'AuthFinish',
	data() {
	  return {
		  name: '',
		  code: ''
	  }
	},
	methods: {
		change() {
			// this.$router.push({name: 'AuthcEnt'})
		}
	},
	created() {
		// this.$api.common.industry(0).then(res => {
		//   if (res.code == 0) {
		//     this.industries = res.data
		//   }
		//   console.log(res)
		// })
		this.$api.user.getAuthFinishInfo().then(res => { 
			this.name = res.data.name
			this.code = res.data.code
			console.log(res)
		})
	}
  }
</script>

<style scoped>
	#finish{
		margin: 150px 300px;
	}
	.finishImgNav{
		float: left;
	}
	.finishConNav{
		float: left;
		margin-left: 60px;
	}
	.congratulations{
		font-size: 16px;
		font-weight: 700;
		color: #000000;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.belowcongratulations{
		height: 20px;
		margin-bottom: 8px;
	}
	.congratulationsother{
		margin-right: 20px;
		float: left;
	}
	.congratulationsPerson{
		font-size: 16px;
		font-weight: 700;
		color: #000000;
		margin-top: 30px;
		margin-bottom: 20px;
	}
	#change{
		font-size: 16px;
		margin-top: 20px;
		color: #02b2f8;
		cursor: pointer;
		width: max-content;
	}
	#change:hover{
		/* border-bottom: 1px solid #02b2f8; */
		text-decoration: underline;
	}
</style>
